import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=074def3b&scoped=true&"
import script from "./Invoices.vue?vue&type=script&lang=ts&"
export * from "./Invoices.vue?vue&type=script&lang=ts&"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=074def3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074def3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('074def3b')) {
      api.createRecord('074def3b', component.options)
    } else {
      api.reload('074def3b', component.options)
    }
    module.hot.accept("./Invoices.vue?vue&type=template&id=074def3b&scoped=true&", function () {
      api.rerender('074def3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/Invoices.vue"
export default component.exports